import {
  createRouter,
  createWebHistory
} from 'vue-router'

const routes = [{
  path: "/",
  // redirect: "/checkPolicy",
  name: "root",
  // component: () => import("@/views/layout/index.vue"),
  children: [{
      path: "/checkPolicy",
      name: "checkPolicy",
      component: () => import("@/views/checkPolicy/index.vue"),
      meta: {
        title: "查保单"
      },
    },
    {
      path: "/checkPolicy/warranty",
      name: "checkPolicy-warranty",
      component: () => import("@/views/checkPolicy/children/warranty.vue"),
      meta: {
        title: "电子保单"
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login/index.vue"),
      meta: {
        title: "登录"
      },
    }, {
      path: "/checkPolicy/details",
      name: "checkPolicy-details",
      component: () => import("@/views/checkPolicy/children/details.vue"),
      meta: {
        title: "保单详情"
      },
    },
    {
      path: "/checkPolicy/details/paymentDetails",
      name: "checkPolicy-details-paymentDetails",
      component: () => import("@/views/checkPolicy/children/payment_details.vue"),
      meta: {
        title: "缴费详情"
      },
    },
    {
      path: "/checkPolicy/details/modifyInformation",
      name: "checkPolicy-details-modifyInformation",
      component: () => import("@/views/checkPolicy/children/modify_information.vue"),
      meta: {
        title: "投保人信息修改"
      },
    },
    {
      path: "/checkPolicy/details/insured",
      name: "checkPolicy-details-insured",
      component: () => import("@/views/checkPolicy/children/insured.vue"),
      meta: {
        title: "被投保人信息修改"
      },
    },
    {
      path: "/overseas",
      name: "overseas",
      component: () => import("@/views/overseas/index.vue"),
      meta: {
        title: "投保"
      },
    },
    {
      path: "/policyholder",
      name: "policyholder",
      component: () => import("@/views/policyholder/index.vue"),
      meta: {
        title: "投保人信息"
      },
    },
    {
      path: "/beInsured",
      name: "beInsured",
      component: () => import("@/views/beInsured/index.vue"),
      meta: {
        title: "被保险人信息"
      },
    },
    {
      path: "/verify",
      name: "verify",
      component: () => import("@/views/verify/index.vue"),
      meta: {
        title: "信息确认"
      },
    },
    {
      path: "/payComplete",
      name: "payComplete",
      component: () => import("@/views/payComplete/index.vue"),
      meta: {
        title: "支付完成"
      },
    },
    {
      path: "/payComplete/warranty",
      name: "payComplete-warranty",
      component: () => import("@/views/payComplete/warranty.vue"),
      meta: {
        title: "查看电子保单"
      },
    },
    {
      path: "/payComplete/invoice",
      name: "payComplete-invoice",
      component: () => import("@/views/payComplete/invoice.vue"),
      meta: {
        title: "查看电子发票"
      },
    },
  ]
}]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果 `savedPosition` 存在，则表示这是通过浏览器的前进/后退按钮导航，此时返回保存的位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则返回顶部
      return {
        top: 0
      };
    }
  }
});

export default router